<script lang="ts">
  import type { PwNextFocusWrapperProps } from './types';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  export let entryId: PwNextFocusWrapperProps['entryId'];
  export let customCssClass: PwNextFocusWrapperProps['customCssClass'];
  export let content: PwNextFocusWrapperProps['content'];
</script>

<div class="PwNextFocusWrapper PwNextFocusWrapper-{entryId}-box-properties {customCssClass}" data-entry-id={entryId}>
  {#each content as entry}
    {#if entry?.link}
      <a href={entry?.link}>
        <DynamicChildrenComponent children={[entry]} />
      </a>
    {:else}
      <DynamicChildrenComponent children={[entry]} />
    {/if}
  {/each}
</div>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/core/config/_media_queries' as media;

  @layer custom-components {
    .PwNextFocusWrapper {
      display: flex;

      @include media.until('medium') {
        flex-direction: column;
        gap: var(--space-60);
      }

      :global {
        .AproposImageComponent:nth-child(1) img {
          transition: transform var(--duration-default) var(--easing-standard);
        }

        & > * {
          &:hover {
            .AproposImageComponent:nth-child(1) img {
              transform: scale(var(--zoom-in-scale));
            }
          }
        }
      }
    }
  }
</style>
